import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Flex } from '@chakra-ui/react';
import './working-hours.scss';
import { styles } from './working-hours.styles';
import Input from '../../components/input/input';
const WorkingHours = (props)=>{
    const { hours, activeDays, setHours, setActiveDays } = props;
    const classes = styles();
    const toggleDay = (day)=>{
        if (hours[day] > 0 && activeDays[day]) {
            hours[day] = 0;
        }
        setActiveDays({
            ...activeDays,
            [day]: !activeDays[day]
        });
    };
    const handleHourChange = (day, value)=>{
        if (value <= 24 && value > -1 || Number.isNaN(value)) {
            if (Number.isNaN(value)) {
                value = 0;
            }
            setHours({
                ...hours,
                [day]: value
            });
        }
    };
    const calculateTotalHours = ()=>{
        let total = 0;
        for(const day in hours){
            if (!Number.isNaN(hours[day]) && hours[day] > 0 && hours[day] <= 24) {
                total += hours[day];
            }
        }
        return total;
    };
    const refreshActiveDays = ()=>{
        let newActiveDays = activeDays;
        Object.keys(activeDays).forEach((day)=>hours[day] > 0 && !activeDays[day] ? newActiveDays[day] = true : newActiveDays[day] = activeDays[day]);
        setActiveDays(newActiveDays);
        return newActiveDays;
    };
    return /*#__PURE__*/ _jsxs(Flex, {
        flexDirection: 'column',
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: classes.dayContainer,
                children: Object.keys(refreshActiveDays()).map((day, index)=>/*#__PURE__*/ _jsxs("label", {
                        className: "day-checkbox",
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "checkbox",
                                checked: activeDays[day],
                                onChange: ()=>toggleDay(day)
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "checkmark",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "day-label",
                                    children: day.substring(0, 1)
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ _jsx("div", {
                children: Object.keys(hours).map((day)=>activeDays[day] && /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes.hoursRow,
                        children: [
                            /*#__PURE__*/ _jsxs("label", {
                                style: classes.dayInputLabel,
                                children: [
                                    day,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: classes.hourInputContainer,
                                children: [
                                    /*#__PURE__*/ _jsx(Input, {
                                        className: 'hour-input',
                                        type: "number",
                                        value: hours[day].toString(),
                                        onChange: (e)=>handleHourChange(day, parseInt(e.target.value))
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: classes.hourInputLabel,
                                        children: "hours"
                                    })
                                ]
                            })
                        ]
                    }, day))
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        style: classes.totalLabel,
                        children: "TOTAL HOURS: "
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        style: classes.totalValue,
                        children: calculateTotalHours()
                    })
                ]
            })
        ]
    });
};
export { WorkingHours };
